import { cn, useThemeAttribute } from '@shared-ui/utils'
import { DarkLogo, HeaderLogo, LogoIcon } from 'shared/assets/images'

interface AppLogoProps {
    className?: string
    /** `icon` shows only the mark, without the "UniSport Digital" text */
    variant?: 'full' | 'icon'
}

/** Horizontal UniSport Digital logo, blue on light theme and white on dark theme */
export const AppLogo = ({ className, variant = 'full' }: AppLogoProps) => {
    const theme = useThemeAttribute()
    const fullLogo = theme === 'dark' ? DarkLogo : HeaderLogo

    return (
        <img
            src={variant === 'icon' ? LogoIcon : fullLogo}
            alt="UniSport Digital"
            className={cn('h-12 w-auto object-contain', className)}
        />
    )
}
